import { values } from "lodash";
import { MAXIMUM_FILE_COUNT, MAXIMUM_FILE_SIZE } from "./constants";
import { Document, reducer } from "./reducer";

type State = ReturnType<typeof reducer>;

const validations = (document: Document, index: number) => {
  if (index >= MAXIMUM_FILE_COUNT) {
    return "Too many files";
  }

  if (document.file.size >= MAXIMUM_FILE_SIZE) {
    return "File is too large";
  }

  if (document.category === null) {
    return "Category is required";
  }

  return null;
};

export const validate = (state: State): State =>
  values(state).reduce(
    (currentState, document, index) => ({
      ...currentState,
      [document.id]: { ...document, validation: validations(document, index) },
    }),
    state,
  );
